/**
 * core.Table 의 신규 행 표식(DS 계약, pbo-core table/index.tsx `isNewRow`).
 * 이 키가 true 인 행은 편집 전에도 필수(required) 편집 칸이 비어 있으면 행 전체를 빨간 배경(`pbo-v2-error-row`)으로 그린다.
 * 조회 결과 행은 사용자가 편집해야 검사하므로, 엑셀 업로드·행 추가처럼 **사용자가 만든 행**에만 단다.
 *
 * 표시용 표식이라 화면 상태에는 넣지 않는다 — 뷰에 넘기는 행에만 붙이고(`withNewMarker`), 편집 콜백으로 돌아온 행에서 다시 뗀다(`withoutNewMarker`).
 * 저장 본문이 행을 펼쳐 보내는 화면에서 이 키가 API 로 새지 않게 하기 위해서다.
 */
export const NEW_ROW_MARKER = '__new'

export const withNewMarker = <T extends object>(row: T): T & { [NEW_ROW_MARKER]: true } => ({ ...row, [NEW_ROW_MARKER]: true as const })

export const withoutNewMarker = <T extends object>(row: T): T => {
  if (!(NEW_ROW_MARKER in row)) return row
  const rest: Record<string, unknown> = { ...row }
  delete rest[NEW_ROW_MARKER]
  return rest as T
}
